import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

interface SectionLinkProps {
  hash: string;
  to?: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
  ariaCurrent?: "true" | undefined;
}

/**
 * Links to a section of the home page, whether the visitor is already there
 * or is browsing another page of the site.
 */
export default function SectionLink({
  hash,
  to,
  className,
  children,
  onClick,
  ariaLabel,
  ariaCurrent,
}: SectionLinkProps) {
  const { pathname } = useLocation();

  if (to) {
    return (
      <Link to={to} className={className} onClick={onClick} aria-label={ariaLabel}>
        {children}
      </Link>
    );
  }

  if (pathname === "/") {
    return (
      <a
        href={`#${hash}`}
        className={className}
        onClick={onClick}
        aria-label={ariaLabel}
        aria-current={ariaCurrent}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={`/#${hash}`}
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-current={ariaCurrent}
    >
      {children}
    </Link>
  );
}